import ListCell from '@doordash/component-list-cell'
import * as React from 'react'
import { MouseEvent } from 'react'
import { connect } from 'react-redux'
import { i18nKeys } from 'translationTypes'
import * as events from '../../../../../events'
import i18n from '../../../../../i18n'
import * as DA from '../../../../../typeModules/events'
import { loadExternalUrl } from '../../../../../webview'

export enum AbnGuideItem {
  HOW_TO = 'how-to',
  LOOKUP = 'look-up',
  LEARN_MORE = 'learn-more',
}

const ABN_LEARN_MORE_LINK = 'https://dasher.doordash.com/en-au/blog/abn'

const LinkCell = ({ title, ...props }) => (
  <ListCell
    {...props}
    size={ListCell.Sizes.Small}
    iconEnd={{ type: ListCell.IconTypes.ChevronRight }}
    separatorType={ListCell.SeparatorTypes.FullBorder}
    title={title}
  />
)

interface AbnGuideProps {
  onItemClick: (guideItem: AbnGuideItem) => void
  trackBackgroundCheckSteps: (payload: unknown) => void
}

function AbnGuide({ onItemClick, trackBackgroundCheckSteps }: AbnGuideProps) {
  const handleClick = (e: MouseEvent<HTMLElement>, guideItem: AbnGuideItem) => {
    e.preventDefault()

    trackBackgroundCheckSteps({
      page: DA.BackgroundCheckPages.ABN,
      action: DA.EventActions.Clicked,
      value: guideItem,
    })

    if (guideItem === AbnGuideItem.LEARN_MORE) {
      loadExternalUrl(ABN_LEARN_MORE_LINK)
      return
    }
    onItemClick(guideItem)
  }

  return (
    <div>
      <LinkCell
        title={i18n.t(i18nKeys.backgroundCheck__abnHowTo)}
        onClick={e => handleClick(e, AbnGuideItem.HOW_TO)}
      />
      <LinkCell
        title={i18n.t(i18nKeys.backgroundCheck__abnLookup)}
        onClick={e => handleClick(e, AbnGuideItem.LOOKUP)}
      />
      <LinkCell
        title={i18n.t(i18nKeys.backgroundCheck__abnLearnMore)}
        onClick={e => handleClick(e, AbnGuideItem.LEARN_MORE)}
      />
    </div>
  )
}

const mapDispatchToProps = {
  trackBackgroundCheckSteps: events.trackBackgroundCheckSteps,
}

export default connect(null, mapDispatchToProps)(AbnGuide)
